import React, { Component } from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import styled, { ThemeProvider } from "styled-components";
import invertTheme from "../invertTheme.js";
import { Box, Flex } from "rebass";
import {
  Head,
  Button,
  Card,
  CardLayout,
  PrimaryButton,
  H1,
  H2,
  H3,
  H4,
  Text,
  GradientCard,
  Main,
  MobileBar,
} from "components";

class Home extends React.Component {
  static contextTypes = {
    setAltLanguages: PropTypes.func,
  };
  componentDidMount() {
    this.context.setAltLanguages(undefined);
  }
  render() {
    let json = undefined;
    if (this.props.data.home.raw) {
      json = JSON.parse(this.props.data.home.raw);
    }
    return (
      <div
        style={
          this.props.transition ? this.props.transition.style : { opacity: 0 }
        }
      >
        {json && <Head source={json.data} />}
        <Main w="100%" bg="white">
          {json && (
            <div>
              <Box
                w="100%"
                mx="auto"
                pt={[137, 80]}
                px={[4, 5, 6, 8]}
                style={{ maxWidth: "90em" }}
              >
                <Flex
                  is="section"
                  flexDirection={["column", null, "row"]}
                  align="center"
                  mt={[5, 6]}
                  mb={[5, 6]}
                >
                  <Box
                    w={[1, null, 1 / 2]}
                    mb={[5, null, 0]}
                    mr={[0, null, 4]}
                    pr={[0, null, 4]}
                  >
                    {json.data.intro_heading[0] && (
                      <H2
                        children={json.data.intro_heading[0].text}
                        mb={5}
                        fontSize={[5, 6]}
                      />
                    )}
                    {json.data.intro_subheading[0] && (
                      <Text
                        children={json.data.intro_subheading[0].text}
                        fontSize={[2, 3]}
                        mb={48}
                      />
                    )}
                    {json.data.intro_button_text &&
                      json.data.intro_button_link && (
                        <PrimaryButton
                          children={json.data.intro_button_text}
                          is="a"
                          href={json.data.intro_button_link.url}
                        />
                      )}
                  </Box>
                  <Box w={[1, null, 1 / 2]}>
                    <GradientCard
                      image={
                        json.data.tile_1_image
                          ? json.data.tile_1_image.half.url
                          : ""
                      }
                    >
                      {json.data.tile_1_small_title[0] && (
                        <H4
                          children={json.data.tile_1_small_title[0].text}
                          mb={5}
                        />
                      )}
                      {json.data.tile_1_title[0] && (
                        <H2
                          children={json.data.tile_1_title[0].text}
                          mb={5}
                          fontSize={[4, 5]}
                        />
                      )}
                      {json.data.tile_1_subtext[0] && (
                        <Text
                          children={json.data.tile_1_subtext[0].text}
                          fontSize={[2, 3]}
                          mb={96}
                        />
                      )}
                      {json.data.tile_1_button_text && (
                        <PrimaryButton
                          children={json.data.tile_1_button_text}
                          is={Link}
                          to={
                            "/" +
                            this.props.pathContext.lang +
                            json.data.tile_1_button_link
                          }
                        />
                      )}
                    </GradientCard>
                  </Box>
                </Flex>
                <Box is="section" mb={[5, 6]} mx={[-4, 0]}>
                  <CardLayout>
                    <Card object={this.props.data.featured1} />
                    <Card object={this.props.data.featured2} />
                    <Card object={this.props.data.featured3} />
                    <Card object={this.props.data.featured4} />
                  </CardLayout>
                </Box>
                <Box is="section" mb={[5, 6]}>
                  <GradientCard
                    image={
                      json.data.tile_2_image
                        ? json.data.tile_2_image.half.url
                        : ""
                    }
                  >
                    <Box w={[1, null, 1 / 2]}>
                      {json.data.tile_2_small_title[0] && (
                        <H4
                          children={json.data.tile_2_small_title[0].text}
                          mb={5}
                        />
                      )}
                      {json.data.tile_2_title[0] && (
                        <H2
                          children={json.data.tile_2_title[0].text}
                          mb={5}
                          fontSize={[4, 5]}
                        />
                      )}
                      {json.data.tile_2_button_text && (
                        <PrimaryButton
                          children={json.data.tile_2_button_text}
                          is={Link}
                          to={
                            "/" +
                            this.props.pathContext.lang +
                            json.data.tile_2_button_link
                          }
                        />
                      )}
                    </Box>
                  </GradientCard>
                </Box>
                <Box is="section" mx={[-4, 0]} pb={[0, 6]}>
                  <CardLayout>
                    <Card object={this.props.data.featured5} />
                    <Card object={this.props.data.featured6} />
                    <Card object={this.props.data.featured7} />
                    <Card object={this.props.data.featured8} />
                  </CardLayout>
                </Box>
              </Box>
            </div>
          )}
        </Main>
      </div>
    );
  }
}

export default Home;

export const query = graphql`
  query HomeQuery(
    $id: String!
    $featured_content1: String!
    $featured_content2: String!
    $featured_content3: String!
    $featured_content4: String!
    $featured_content5: String!
    $featured_content6: String!
    $featured_content7: String!
    $featured_content8: String!
  ) {
    home: prismicDocument(prismicId: { eq: $id }) {
      raw
      uid
      id
      data {
        region {
          uid
        }
      }
      alternate_languages {
        id
        lang
      }
    }
    featured1: prismicDocument(prismicId: { eq: $featured_content1 }) {
      uid
      type
      lang
      data {
        region {
          uid
        }
        subtitle {
          text
        }
        title {
          text
        }
        description {
          text
        }
        header_image {
          url
          quarter {
            url
          }
          half {
            url
          }
          thumb {
            url
          }
        }
      }
    }
    featured2: prismicDocument(prismicId: { eq: $featured_content2 }) {
      uid
      type
      lang
      data {
        region {
          uid
        }
        subtitle {
          text
        }
        title {
          text
        }
        description {
          text
        }
        header_image {
          url
          quarter {
            url
          }
          half {
            url
          }
          thumb {
            url
          }
        }
      }
    }
    featured3: prismicDocument(prismicId: { eq: $featured_content3 }) {
      uid
      type
      lang
      data {
        region {
          uid
        }
        title {
          text
        }
        subtitle {
          text
        }
        description {
          text
        }
        header_image {
          url
          quarter {
            url
          }
          half {
            url
          }
          thumb {
            url
          }
        }
      }
    }
    featured4: prismicDocument(prismicId: { eq: $featured_content4 }) {
      uid
      type
      lang
      data {
        region {
          uid
        }
        title {
          text
        }
        description {
          text
        }
        subtitle {
          text
        }
        header_image {
          url
          quarter {
            url
          }
          half {
            url
          }
          thumb {
            url
          }
        }
      }
    }
    featured5: prismicDocument(prismicId: { eq: $featured_content5 }) {
      uid
      type
      lang
      data {
        region {
          uid
        }
        title {
          text
        }
        subtitle {
          text
        }
        description {
          text
        }
        header_image {
          url
          quarter {
            url
          }
          half {
            url
          }
          thumb {
            url
          }
        }
      }
    }
    featured6: prismicDocument(prismicId: { eq: $featured_content6 }) {
      uid
      type
      lang
      data {
        region {
          uid
        }
        title {
          text
        }
        subtitle {
          text
        }
        description {
          text
        }
        header_image {
          url
          quarter {
            url
          }
          half {
            url
          }
          thumb {
            url
          }
        }
      }
    }
    featured7: prismicDocument(prismicId: { eq: $featured_content7 }) {
      uid
      type
      lang
      data {
        region {
          uid
        }
        subtitle {
          text
        }
        title {
          text
        }
        description {
          text
        }
        header_image {
          url
          quarter {
            url
          }
          half {
            url
          }
          thumb {
            url
          }
        }
      }
    }
    featured8: prismicDocument(prismicId: { eq: $featured_content8 }) {
      uid
      type
      lang
      data {
        region {
          uid
        }
        subtitle {
          text
        }
        title {
          text
        }
        description {
          text
        }
        header_image {
          url
          quarter {
            url
          }
          half {
            url
          }
          thumb {
            url
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/home_page.js